import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Menu from "../../Components/Menu";

const PayList = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | پرداختی ها";
        token == null && navigate("/login", { replace: true });
    }, []);

    // Filter
    const [showFilter, setShowFilter] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const handleCheckboxChange = (option) => {
        const isSelected = selectedOptions.includes(option);
        setSelectedOptions((prevOptions) =>
            isSelected
                ? prevOptions.filter((selected) => selected !== option)
                : [...prevOptions, option]
        );
    };
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const getList = (e) => {
        let status = {
            filter: selectedOptions && selectedOptions.length !== 0 ? 1 : 0,
            payment_type: selectedOptions,
        };
        let config = {
            url: `${baseUrl}/payment/list`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        getList();
    }, []);
    // Search
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const searchHandler = (e) => {
        const results = list.filter((item) =>
            item.customer.store_name.includes(searchText)
        );
        setSearchResults(results);
    };

    return (
        <div className="container">
            {showFilter && (
                <div
                    onClick={() => {
                        setShowFilter(false);
                    }}
                    id="bg_gray"
                    className="bg-gray"
                ></div>
            )}
            {showFilter && (
                <div
                    id="filter_modal"
                    className="filter-modal filter-les-height"
                >
                    <div className="filter-modal-head">
                        <svg
                            onClick={() => {
                                getList();
                                setShowFilter(false);
                            }}
                            className="orang-filter"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                opacity="0.4"
                                d="M21.89 12C21.89 17.52 17.41 22 11.89 22C6.37 22 3 16.44 3 16.44M3 16.44H7.52M3 16.44V21.44"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <h2>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                                setShowFilter(false);
                            }}
                        >
                            <path
                                d="M21 7L11 7"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M3 17L13 17"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                        فیلتر
                    </h2>
                    <div className="filter-payment">
                        <label>
                            <input
                                type="checkbox"
                                value="CHECK"
                                checked={selectedOptions.includes("CHECK")}
                                onChange={() => handleCheckboxChange("CHECK")}
                            />
                            چک
                        </label>

                        <label>
                            <input
                                type="checkbox"
                                value="CASH"
                                checked={selectedOptions.includes("CASH")}
                                onChange={() => handleCheckboxChange("CASH")}
                            />
                            نقد
                        </label>

                        <label>
                            <input
                                type="checkbox"
                                value="CARD"
                                checked={selectedOptions.includes("CARD")}
                                onChange={() => handleCheckboxChange("CARD")}
                            />
                            کارتخوان
                        </label>
                    </div>
                </div>
            )}
            <div className="search-box" id="search_box">
                <div className="pos-rel-search">
                    <input
                        onChange={(e) => setSearchText(e.target.value)}
                        value={searchText}
                        type="text"
                        placeholder="جستجو کنید"
                    />
                    <svg
                        onClick={searchHandler}
                        className="search-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M16.5 16.958L21.5 21.958"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <div className="svg-rec" onClick={() => setShowFilter(true)}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M21 7L11 7"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            d="M3 17L13 17"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
            </div>
            {loading ? (
                <div className="emp-main">
                    <img src="/assets/images/loading.gif" width={50} />
                </div>
            ) : list && list.length !== 0 ? (
                <div className="orders-main">
                    <h1>لیست پرداختی ها</h1>
                    {searchResults && searchResults.length !== 0
                        ? searchResults &&
                          searchResults.length !== 0 &&
                          searchResults.map((item) => {
                              return (
                                  <a
                                      className="orders-card"
                                      onClick={() => {
                                          navigate("/panel/pay/" + item.id);
                                      }}
                                  >
                                      <img src={item.customer.avatar} alt="" />
                                      <div>
                                          <span className="name">
                                              {item.customer.store_name}
                                          </span>
                                          <span className="fullname">
                                              {item.customer.name}{" "}
                                          </span>
                                          <span className="numb">
                                              {item.code}
                                          </span>
                                          <div className="dates">
                                              <button>
                                                  {item.type == "CASH"
                                                      ? "نقدی"
                                                      : item.type == "CARD"
                                                      ? "کارتخوان"
                                                      : "چک"}
                                              </button>
                                              <span>{item.Created_at}</span>
                                          </div>
                                      </div>
                                  </a>
                              );
                          })
                        : list &&
                          list.length !== 0 &&
                          list.map((item) => {
                              return (
                                  <a
                                      className="orders-card"
                                      onClick={() => {
                                          navigate("/panel/pay/" + item.id);
                                      }}
                                  >
                                      <img src={item.customer.avatar} alt="" />
                                      <div>
                                          <span className="name">
                                              {item.customer.store_name}
                                          </span>
                                          <span className="fullname">
                                              نام و نام خانوادگی:{" "}
                                              {item.customer.name}{" "}
                                              {item.customer.family}
                                          </span>
                                          <span className="numb">
                                              {item.code}
                                          </span>
                                          <div className="dates">
                                              <button>
                                                  {item.type == "CASH"
                                                      ? "نقدی"
                                                      : item.type == "CARD"
                                                      ? "کارتخوان"
                                                      : "چک"}
                                              </button>
                                              <span>{item.Created_at}</span>
                                          </div>
                                      </div>
                                  </a>
                              );
                          })}
                </div>
            ) : (
                <div className="emp-main">
                    <svg
                        width="145"
                        height="145"
                        viewBox="0 0 145 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M30.2084 90.625C24.5292 90.625 19.273 92.6188 15.1042 95.9417C9.54591 100.352 6.04175 107.179 6.04175 114.792C6.04175 119.323 7.31051 123.612 9.54593 127.237C13.7147 134.246 21.3876 138.958 30.2084 138.958C36.3105 138.958 41.8689 136.723 46.098 132.917C47.9709 131.346 49.6022 129.412 50.8709 127.237C53.1063 123.612 54.3751 119.323 54.3751 114.792C54.3751 101.44 43.5605 90.625 30.2084 90.625ZM42.7147 112.194L29.8459 124.096C29.0001 124.881 27.8521 125.304 26.7646 125.304C25.6167 125.304 24.4688 124.881 23.5625 123.975L17.5814 117.994C15.8293 116.242 15.8293 113.341 17.5814 111.589C19.3334 109.837 22.2334 109.837 23.9855 111.589L26.8855 114.49L36.5522 105.548C38.3647 103.856 41.2647 103.977 42.9563 105.79C44.648 107.602 44.5272 110.502 42.7147 112.194Z"
                            fill="#6883DC"
                        />
                        <path
                            opacity="0.4"
                            d="M117.692 78.2397H129.896V69.5397C129.896 57.0334 119.686 46.8229 107.179 46.8229H37.8209C25.3146 46.8229 15.1042 57.0334 15.1042 69.5397V95.9417C19.273 92.6188 24.5292 90.625 30.2084 90.625C43.5605 90.625 54.3751 101.44 54.3751 114.792C54.3751 119.323 53.1063 123.613 50.8709 127.238C49.6022 129.413 47.9709 131.346 46.098 132.917H107.179C119.686 132.917 129.896 122.706 129.896 110.2V103.01H118.417C111.892 103.01 105.911 98.2375 105.367 91.7125C105.004 87.9062 106.454 84.3416 108.992 81.8645C111.227 79.5687 114.308 78.2397 117.692 78.2397Z"
                            fill="#6883DC"
                        />
                        <path
                            d="M89.7189 23.8646V46.8229H37.8209C25.3146 46.8229 15.1042 57.0333 15.1042 69.5396V47.3668C15.1042 40.1772 19.5146 33.7728 26.2209 31.2353L74.1917 13.1103C81.6834 10.3311 89.7189 15.8292 89.7189 23.8646Z"
                            fill="#6883DC"
                        />
                        <path
                            d="M136.3 84.4019V96.8481C136.3 100.171 133.642 102.889 130.258 103.01H118.417C111.892 103.01 105.91 98.2374 105.367 91.7124C105.004 87.9062 106.454 84.3416 108.992 81.8645C111.227 79.5686 114.308 78.2396 117.692 78.2396H130.258C133.642 78.3605 136.3 81.079 136.3 84.4019Z"
                            fill="#6883DC"
                        />
                        <path
                            d="M84.5834 77.0312H42.2917C39.8147 77.0312 37.7605 74.9771 37.7605 72.5C37.7605 70.0229 39.8147 67.9688 42.2917 67.9688H84.5834C87.0605 67.9688 89.1147 70.0229 89.1147 72.5C89.1147 74.9771 87.0605 77.0312 84.5834 77.0312Z"
                            fill="#6883DC"
                        />
                    </svg>

                    <p className="emp-text">هیچ پرداختی ثبت نشده است</p>
                </div>
            )}
            <Menu active="cart" />
        </div>
    );
};

export default PayList;
